import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/login.service';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-erro-401',
  templateUrl: './erro-401.component.html',
  styleUrls: ['./erro-401.component.scss']
})
export class Erro401Component implements OnInit {

  constructor(private loginService: LoginService, private router: Router) { }

  ngOnInit() {
    this.loginService.getLogIn().pipe(first()).subscribe(l => {
      if (!l) {
        this.router.navigate(['']);
      }
    })
  }

}
